module.exports = __webpack_public_path__ + "main/assets/fonts/petalmd/petalmd-455a334185acc39d2fc4eb1b12e836e1.eot";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/petalmd/petalmd.eot
// module id = 228
// module chunks = 0